import styled from 'styled-components';

export const BackgroundGradient = styled.div`
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.color.secondaryGradient};
  width: 100%;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  padding: 30px;
  align-items: baseline;
  justify-content: center;
  margin-top: 200px;
  max-width: 1200px;
  h4 {
    text-decoration: none;
    white-space: nowrap;
  }
`;

export const StyledHeadingDesktop = styled.h4`
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`;

export const StyledHeadingMobile = styled.h4`
  font-size: 1.2rem;
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;
